import { T01_01 } from "./T01_01"

export const T01 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Doctor's List of Medical Doctors within Territory Code",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'MD Name',
                        "columnName": 'CustomerName',
                        "width": '300px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Hospital Affiliation',
                        "columnName": 'HospitalAffiliation',
                        "width": '300px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": 'Frequency',
                        "columnName": 'Frequency',
                        "width": '200px',
                        "align": "right",
                        "sortable": true
                    },
                    {
                        "name": 'Sponsorship',
                        "columnName": 'Sponsorship',
                        "width": '200px',
                        "align": "right",
                        "sortable": true
                    }
                ],
                "title": "CustomerName",
                "endpoint": "T01",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "ConfigTypeCode", "value": "" },
                    { "key": "AgentCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": T01_01
                }
            }
        }
    }
}